<mat-toolbar class="toolbar">
  <div>
    <h2 style="margin:0">Authenticating Please wait...</h2>
  </div>
</mat-toolbar>
<mat-dialog-content class="dialog-content">
  <div class="spinner-wrapper">
    <mds-loader></mds-loader>
  </div>
  <span>Redirecting</span>
</mat-dialog-content>
